
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.6326 0H3.36739C1.51206 0 0 1.51206 0 3.37556V10C0 10.4046 0.331018 10.7356 0.735595 10.7356H12.0433L10.4209 12.358C10.1349 12.6441 10.1349 13.1099 10.4209 13.4001C10.564 13.5431 10.7519 13.6167 10.9399 13.6167C11.1279 13.6167 11.3159 13.5431 11.4589 13.4001L14.3359 10.5231C14.622 10.237 14.622 9.77115 14.3359 9.481L11.4589 6.60401C11.1729 6.31794 10.707 6.31794 10.4168 6.60401C10.1308 6.89007 10.1308 7.35595 10.4168 7.6461L12.0433 9.26441H1.47119V3.37556C1.47119 2.3253 2.32121 1.47119 3.36739 1.47119H16.6326C17.6788 1.47119 18.5288 2.3253 18.5288 3.37556V16.6244C18.5288 17.6747 17.6788 18.5288 16.6326 18.5288H3.36739C2.32121 18.5288 1.47119 17.6747 1.47119 16.6244V14.9081C1.47119 14.5035 1.14017 14.1725 0.735595 14.1725C0.331018 14.1725 0 14.5035 0 14.9081V16.6244C0 18.4839 1.51206 20 3.36739 20H16.6326C18.4879 20 20 18.4879 20 16.6244V3.37556C20 1.51614 18.4879 0 16.6326 0Z"}})])
          )
        }
      }
    